import { defineClassNames } from '../../utils/defineClassNames';

export const classes = defineClassNames('segmented-toggle-icon', {
  root: {
    variants: {
      size: ['tiny', 'small', 'medium'],
    },
    states: ['selected'],
  },
  tooltip: {},
  textWrapper: {},
});
